import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {loginService} from './login.service';
import {ToastsManager} from 'ng2-toastr/ng2-toastr';
import {Router} from '@angular/router';
import {MstUnitService} from '../configuration/mst-unit/mst-unit.service';
import {MstCashCounterService} from '../configuration/mst-cash-counter/mst-cash-counter.service';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';
import {Aarogyam, COVID, Iilds, MataPita, Karad, Medikal, MK, Nepal, Tata, Tawau, Turkish, SSPM, YCM, Nigeria, swaraj} from '../shared/my-constants';
import {MstStaffService} from '../configuration/mst-staff/mst-staff.service';
import {Observable} from 'rxjs/Observable';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
    currentUser: any;
    LoginForm: FormGroup;
    mstUnitList: Array<any> = [];
    mstCashCounterList: Array<any> = [];
    mstUnitListUserWise = [];
    unitName: any;
    result: any = {};
    flag = false;
    /*      template: string =`<img src="http://pa1.narvii.com/5722/2c617cd9674417d272084884b61e4bb7dd5f0b15_hq.gif" />`*/
    template: string = `<img src="/assets/loading1.gif"/>`;
    timeout = '4000';
    zIndex = '9999';
    iilds: Boolean = Iilds;
    nepal: Boolean = Nepal;
    tata: Boolean = Tata;
    aarogyam: Boolean = Aarogyam;
    ycm: Boolean = YCM;
    turkish: Boolean = Turkish;
    medikal: Boolean = Medikal;
    tawau: Boolean = Tawau;
    mk: Boolean = MK;
    matapita: Boolean = MataPita;
    sspm: Boolean = SSPM;
    karad: Boolean = Karad;
    covid: Boolean = COVID;
    nigeria: Boolean = Nigeria;
    swaraj: Boolean = swaraj;
    passwordVisible: any = false;
    passwordFieldType: any = 'password';
    // alive = true;

    constructor(private fb: FormBuilder,
                private loginService: loginService,
                private router: Router,
                private toastr: ToastsManager,
                private mstUnitService: MstUnitService,
                private mstCashCounterService: MstCashCounterService,
                private spinnerService: Ng4LoadingSpinnerService,
                private mstStaffService: MstStaffService,
                private vcr: ViewContainerRef) {
        this.toastr.setRootViewContainerRef(vcr);
        this.LoginForm = fb.group({
            'userName': [null, Validators.required],
            'password': [null, Validators.required],
            'unitId': [null, Validators.required],
            'cashCounterId': [null],
            'lltUnitName':  [null],
            'ipAddress':  [null],
        });
    }
    // isActive=false;
    // active(){
    //     this.isActive=!this.isActive;
    //     console.log("Inside Active",this.isActive);
    //     // this.getPage(1);
    // }
    // deactive(){
    //     this.isActive=!this.isActive;
    //     console.log("Inside Deactive",this.isActive);
    //     // this.getDeactivatedPage(1);
    // }

    ngOnInit() {
        sessionStorage.clear();

        // Observable.timer(0,10000)
        //     .takeWhile(() => this.alive) // only fires when component is alive
        //     .subscribe(() => {
        //        console.log('Chetan');
        //     });

    }

    getUnitList(event: any) {
        this.mstUnitListUserWise = [];
        this.loginService.getUnitListByUsername(event).then(resp => {

            const unitlist = resp;
            if (unitlist.length == 1) {
                this.LoginForm.controls.unitId.setValue(unitlist[0].unitId);
            }
            for (const mstUnit of unitlist) {
                if (mstUnit.isDeleted !== true) {
                    this.mstUnitListUserWise.push(mstUnit);
                }
            }
        });
    }

    checkLicenseAgreement(value: any) {
        this.loginService.addRecordService().then(resp => {
            if (resp.success === '1') {
                if (resp.object != null) {
                    localStorage.setItem('aboutUs', JSON.stringify(resp.object));
                }
                this.onLoginAction(value);
            }
            else if (resp.success === '2') {
                this.toastr.warning('Server License link failure', 'Alert!');
            }
            else if (resp.success === '3') {
                this.toastr.warning('Software License has Expired. Please Contact to Medify ! ', 'Alert!');
            }
        });
    }

    onLoginAction(value: any) {
        for (let unit of this.mstUnitListUserWise) {
            if (unit.unitId == value.unitId) {
                this.unitName = unit.unitName;
            }
        }
        var ip = window.location.origin
        console.log('ip : ' + ip);
        value.lltUnitName = this.unitName;
        value.ipAddress = ip;

        this.spinnerService.show();
        this.loginService.loginAction(value).subscribe(resp => {
            console.log('resp come :', resp);
            setTimeout(() => {
                if (resp.login_status) {
                    this.spinnerService.hide();
                    this.toastr.success('Login Successfully!', null, {toastLife: 2000});
                    sessionStorage.setItem('unitId', value.unitId);
                    sessionStorage.setItem('unitName', this.unitName);
                    sessionStorage.setItem('userdetail', JSON.stringify(resp.user_detail));
                    sessionStorage.setItem('useraction', JSON.stringify(resp.user_action));
                    sessionStorage.setItem('login_json', JSON.stringify(resp.login_json));
                    this.currentUser = JSON.parse(sessionStorage.getItem('userdetail'));
                    this.mstStaffService.checkRecordByUnitIdAndStaffId(value.unitId, resp.user_detail.staffId).then(resp1 => {
                    if (resp1.success == 1){
                        console.log('staff Cong :', resp1.content);
                        sessionStorage.setItem('staff_config', JSON.stringify(resp1.content));
                    }
                    });
                    this.router.navigate(['/configuration/homesortcut']);
                }
                else {
                    this.spinnerService.hide();
                    this.toastr.error('Invalid Username Password', null, {toastLife: 1000});
                }
            }, 500);
        });
    }

    getCashCounterList(unitId: any) {
        this.mstCashCounterService.getCCListByUnitId(unitId).then(resp => {
            this.mstCashCounterList = resp;
        });
    }

    togglePasswordVisibility(): void {
        this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
        this.passwordVisible = this.passwordFieldType === 'password' ? false : true;
    }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/login/login.component.ts